import { render, staticRenderFns } from "./Holiday.vue?vue&type=template&id=e356b0b4&scoped=true&"
import script from "./Holiday.vue?vue&type=script&lang=js&"
export * from "./Holiday.vue?vue&type=script&lang=js&"
import style0 from "./Holiday.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Holiday.vue?vue&type=style&index=1&id=e356b0b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e356b0b4",
  null
  
)

export default component.exports